/* Caddie for Harmony Cookies v1.9.0: the theme's own cookie banner on Shopify's Customer Privacy API.
   No dependencies. Loads the API with Shopify.loadFeatures (consent-tracking-api 0.1), then:
   - opens by itself when the consent_everywhere setting is on (default), or else when customerPrivacy.shouldShowBanner() is true, AND the shopper has not chosen yet
     (currentVisitorConsent() has no analytics, marketing or preferences answer); it does not take focus then;
   - Accept all / Reject all / Choose: each calls setTrackingConsent({analytics, marketing, preferences});
     Choose shows three unticked boxes (ticked only where the shopper said yes before) and Save my choices;
   - the footer's Cookie settings button ([data-cb-open]) reopens it with focus on its heading; Esc or the
     close button then closes it and gives focus back to that button.
   If the API never loads, nothing shows and the footer button stays hidden. */
(function () {
  'use strict';
  var box = document.querySelector('[data-consent]');
  if (!box) return;
  var KINDS = ['analytics', 'marketing', 'preferences'];
  var form = box.querySelector('[data-cb-form]');
  var chooseBtn = box.querySelector('[data-cb="choose"]');
  var closeBtn = box.querySelector('[data-cb-close]');
  var status = box.querySelector('[data-cb-status]');
  var live = document.querySelector('[data-live]');
  var openers = document.querySelectorAll('[data-cb-open]');
  var api = null, isOpen = false, reopened = false, last = null, busy = false;
  var T = {
    saved: box.getAttribute('data-saved') || '',
    error: box.getAttribute('data-error') || ''
  };

  function current() {
    try { return (api && api.currentVisitorConsent && api.currentVisitorConsent()) || {}; } catch (e) { return {}; }
  }
  function undeclared() {
    var c = current();
    return KINDS.every(function (k) { return !c[k]; });
  }
  function onKey(e) {
    if (e.key === 'Escape' && isOpen && reopened) { e.preventDefault(); hide(true); }
  }
  function show(byShopper) {
    reopened = !!byShopper;
    last = byShopper ? document.activeElement : null;
    closeBtn.hidden = !reopened;
    setChoose(false);
    status.textContent = '';
    box.hidden = false;
    isOpen = true;
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-open'); }); });
    document.addEventListener('keydown', onKey, true);
    if (byShopper) box.querySelector('.cb-h').focus({ preventScroll: true });
    box.dispatchEvent(new CustomEvent('consent:open', { bubbles: true }));
  }
  function hide(giveBack) {
    if (!isOpen) return;
    isOpen = false;
    box.classList.remove('is-open');
    box.hidden = true;
    document.removeEventListener('keydown', onKey, true);
    var back = last; last = null;
    if (giveBack !== false && back && back !== document.body && document.contains(back)) back.focus({ preventScroll: true });
    box.dispatchEvent(new CustomEvent('consent:close', { bubbles: true }));
  }
  function setChoose(on) {
    form.hidden = !on;
    chooseBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    box.classList.toggle('is-choosing', on);
    if (on) {
      var c = current();
      KINDS.forEach(function (k) { var i = form.elements[k]; if (i) i.checked = c[k] === 'yes'; });
    }
  }
  function save(v) {
    if (!api || busy) return;
    busy = true;
    status.textContent = '';
    try {
      api.setTrackingConsent(v, function (res) {
        busy = false;
        if (res && res.error) { status.textContent = T.error; return; }
        hide(true);
        if (live) { live.textContent = ''; setTimeout(function () { live.textContent = T.saved; }, 50); }
      });
    } catch (e) { busy = false; status.textContent = T.error; }
  }
  function all(yes) { var v = {}; KINDS.forEach(function (k) { v[k] = yes; }); return v; }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cb]');
    if (b) {
      var what = b.getAttribute('data-cb');
      if (what === 'accept') save(all(true));
      else if (what === 'reject') save(all(false));
      else if (what === 'choose') {
        var on = form.hidden;
        setChoose(on);
        if (on) { var first = form.querySelector('input'); if (first) first.focus(); }
      }
      return;
    }
    if (e.target.closest('[data-cb-close]')) { e.preventDefault(); hide(true); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = {}; KINDS.forEach(function (k) { v[k] = !!(form.elements[k] && form.elements[k].checked); });
    save(v);
  });
  Array.prototype.forEach.call(openers, function (o) {
    o.addEventListener('click', function (e) { e.preventDefault(); if (!api) return; if (isOpen) { box.querySelector('.cb-h').focus(); return; } show(true); });
  });

  function ready() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.setTrackingConsent !== 'function') { api = null; return; }
    Array.prototype.forEach.call(openers, function (o) { o.hidden = false; });
    var need = false;
    if (box.getAttribute('data-everywhere') === 'true') { need = true; } else {
      try { need = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner(); } catch (e) { need = false; }
    }
    if (need && undeclared()) show(false);
  }
  var tries = 0;
  function load() {
    if (window.Shopify && window.Shopify.customerPrivacy) { ready(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) ready(); });
      return;
    }
    if (++tries < 20) setTimeout(load, 250);
  }
  load();
})();
